export enum RoomVersionCompatibility {
	CompatibleLatest = 'COMPATIBLE_LATEST',
	CompatibleOld = 'COMPATIBLE_OLD',
	IncompatibleTooNew = 'INCOMPATIBLE_TOO_NEW',
	Unknown = 'UNKNOWN'
}
